export default __webpack_public_path__ + "static/media/facebook_author.1e1ab9d3.svg";